"use strict";

exports.__esModule = true;
exports.mergeTheme = mergeTheme;

var _deepmerge = _interopRequireDefault(require("deepmerge"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mergeTheme(theme, themeInput) {
  if (!themeInput) return theme;
  return (0, _deepmerge.default)(theme, themeInput, {
    arrayMerge: (leftArray, rightArray) => rightArray || leftArray
  });
}